export default {
  login: {
    getLoginInfo: ['get', '/auth/login', { baseUrl: '/api/v1', noAuth: true }],
  },
};
